//#region src/errors.ts
/**
* A call to this function is required in each `catch {}` block in a try/catch
* It exists to lower the likelihood of handling one type of error and ignoring
* everything else
*/
function assertCanHandle(err, canHandle) {
	if (!canHandle(err)) throw err;
}
//#endregion
export { assertCanHandle };
